import { http } from 'services/http';
import type { TEntityIdRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteTripVariables {
  tripId: number;
}

export const useDeleteTrip = () => {
  return useMutationBase<TEntityIdRes, unknown, IDeleteTripVariables>({
    mutationFn: async ({ tripId }) => {
      const res = await http.delete<TEntityIdRes>(`/v1/trips/${tripId}`);

      return res.data;
    },
  });
};
